import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import RespIm from "./RespIm";
import "../css/botones.css";

function SignIn(props) {
  const [validated, setValidated] = useState(false);
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    }
  };
  return (
    <div
      style={{
        alignContent: "center",
        paddingLeft: "1%",
        paddingRight: "1%",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <RespIm
          x0={1003}
          y0={700}
          x={200}
          src={require("../images/Logo.png").default}
        />
      </div>
      <Row fluid className="justify-content-center" style={{ margin: "auto" }}>
        <Col Col xs={12} xl={8}>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            id="Forma"
          >
            <Form.Group className="mb-3" controlId="nombre">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese su nombre"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su nombre
              </Form.Control.Feedback>
              <Form.Text className="text-muted"></Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="apellido">
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese su apellido"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su apellido
              </Form.Control.Feedback>
              <Form.Text className="text-muted"></Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="dni">
              <Form.Label>DNI</Form.Label>
              <Form.Control
                type="text"
                placeholder="Por favor ingrese su documento de identidad (Argentinos unicamente)"
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su documento de identidad si e Argentino
              </Form.Control.Feedback>
              <Form.Text className="text-muted"></Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingrese su dirección de email"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su email
              </Form.Control.Feedback>
              <Form.Text className="text-muted"></Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="userPassWord">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Ingrese su clave"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su clave
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="userPassWord2">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Reingrese su clave"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor reingrese su clave
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Row
        fluid
        className="justify-content-center"
        style={{ paddingTop: "4px", margin: "auto" }}
      >
        <Col xs={6} xl={4} className="text-center">
          <button class="botones2" onClick={() => registrar(props)}>
            Registrarme
          </button>
        </Col>
        <Col xs={6} xl={4} className="text-center">
          <button class="botones2" onClick={() => props.setEstado({ n: 0 })}>
            Volver
          </button>
        </Col>
      </Row>
    </div>
  );

  function registrar(props) {
    const form = document.getElementById("Forma");
    if (form.checkValidity() === true) {
      const clave = document.getElementById("userPassWord").value;
      const clave2 = document.getElementById("userPassWord2").value;
      if (clave === clave2) {
        const nombre = document.getElementById("nombre").value;
        const apellido = document.getElementById("apellido").value;
        const email = document.getElementById("email").value;
        const dni = document.getElementById("dni").value;
        registrame(nombre, apellido, dni, email, clave)
          .then((json) => {
            if (json.status !== 200) {
              alert(json.message);
            } else {
              props.setEstado({ n: 3 });
            }
          })
          .catch((error) => alert(error));
      } else {
        alert("Las claves no coinciden");
      }
    } else {
      setValidated(true);
    }
    async function registrame(nombre, apellido, dni, email, clave) {
      const res = await fetch(
        "https://entrenamientopostural.com/services/PHP/register.php",
        {
          method: "POST",
          headers: {
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: JSON.stringify({
            nombre: nombre,
            apellido: apellido,
            dni: dni,
            email: email,
            clave: clave,
          }),
        }
      );

      const Output = await res.json();
      return Output;
    }
  }
}
export default SignIn;
